var map = {
	"./": [
		196,
		2
	],
	"./de": [
		315,
		3
	],
	"./de.js": [
		315,
		3
	],
	"./en": [
		316,
		4
	],
	"./en.js": [
		316,
		4
	],
	"./index": [
		196,
		2
	],
	"./index.js": [
		196,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 428;
module.exports = webpackAsyncContext;